<email-layout>
  <ng-container logo>
    <email-tellent-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data.p1" />&nbsp;
    <email-margin [height]="28" />
    <email-text [contents]="data.p2_1_html" />
    <br />
    <email-text [contents]="data.p2_2_html" />
    <email-margin [height]="28" />
    <hr />
    <email-margin [height]="28" />
    <email-text [contents]="data.p3" />
    <email-margin [height]="16" />
    <email-button [href]="data.help_center_url" [label]="data.help_center_url" theme="accent" />
    <email-margin [height]="16" />
    <email-button [href]="data.log_in_link.href" [label]="data.log_in_link.label" theme="primary" />
  </ng-container>
  <ng-container footer>
    <email-text
      [contents]="data.footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data.footer.label"
      [href]="data.footer.href"
      [target]="data.footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
    <email-margin [height]="16" />
    <email-tellent-products-footer />
  </ng-container>
</email-layout>
